import React, { useState, useEffect } from "react";
import { useFormik, Field } from "formik";
import Cookies from "js-cookie";
// import { TextField } from "formik-mui";
import { useNavigate } from "react-router-dom";
import * as yup from "yup";

import {
  Button,
  Dialog,
  DialogContent,
  DialogActions,
  DialogTitle,
  Typography,
} from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";
import { CloseOutlined, ArrowBackOutlined } from "@mui/icons-material";

import { useSelector, useDispatch } from "react-redux";
import { logout, login } from "../redux/logger/logActions";
import Axios from "axios";
import FormInput from "./FormInput";
import "./formInput.css";
import HeaderText from "./HeaderText";
import ButtonGoogle from "./ButtonGoogle";
//import ButtonGoogle from "./ButtonGoogle";
import { loginSchema } from "../schemas";
import { basePath } from "../utility";

import useHttp from "../hooks/useHttp";

const LoginPage = ({
  openLoginDialog,
  setOpenLoginDialog,
  logType,
  setLogType,
}) => {
  Axios.defaults.withCredentials = true;
  const Navigate = useNavigate();
  const [errorMessage, sendHttpRequest] = useState();
  const [loginMessage, setLoginMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [loginData, setLoginData] = useState(null);
  const [loginError, setLoginError] = useState(null);
  const [feedback, setFeedback] = useState(null);

  const [loadingGoodleAuth, setLoadingGoodleAuth] = useState(false);
  const [errorGoogleAuth, setErrorGoogleAuth] = useState(null);

  const login_status = useSelector((state) => state.logger);
  const dispatch = useDispatch();
  const [logText, setLogText] = useState("");
  const initialValuesLogin = {
    loginEmail: "",
    loginPassword: "",
  };
  const initialValuesReset = {
    resetEmail: "",
  };

  useEffect(() => {
    // setLogText("");
    // setLoading(false);
    // setLoginError(null);
  }, []);

  function navigate_oath(url) {
    window.location.href = url;
  }
  const handleGoogleLogin = async () => {
    try {
      setLoadingGoodleAuth(true);
      setErrorGoogleAuth(null);
      const response = await Axios.get(`${basePath.url}auth/google-auth-url`);
      const data = response.data;
      navigate_oath(data.url);
      setLoadingGoodleAuth(false);
      setErrorGoogleAuth(null);
    } catch (err) {
      setErrorGoogleAuth(err.message);
      setLoadingGoodleAuth(false);
    }
    // setLoadingGoodleAuth(true);
    // const response = await Axios.get(`${basePath.url}auth/google-auth-url`);
    // const data = response.data;
    // // console.log(data);
    // navigate_oath(data.url);
  };
  const onSubmitLogin = async (values, actions) => {
    setLoginData(null);
    setLoading(true);
    setLoginError(null);
    setFeedback(null);
    try {
      const data = {
        email: values.loginEmail,
        password: values.loginPassword,
      };
      const baseUrl = `${basePath.url}auth/login`;

      const result = await Axios.post(baseUrl, data);

      if (result.data.message === "success") {
        // const user = {
        //   userId: result.data.user.id,
        //   name: result.data.user.name,
        //   email: result.data.user.email,
        //   mobileNo: result.data.user.mobileNo,
        // };
        // console.log(result.data);

        // const user = {
        //   userId: result.data.user.id,
        //   name: result.data.user.name,
        //   email: result.data.user.email,
        //   mobileNo: result.data.user.mobileNo,
        // };

        dispatch(login(result.data.user));

        actions.resetForm();
        setLogText("");

        setFeedback("login Success");
        setLoading(false);
        setLoginError(null);

        setOpenLoginDialog(false);
        Navigate("/user-profile");
      } else {
        setLoading(false);
        setLoginError(result.data.description);
        // actions.resetForm();
      }
    } catch (err) {
      setLoading(false);
      setLoginError(err.message);
      // actions.resetForm();
    }
  };

  const onSubmitReset = async (values, actions) => {
    setLogText("");
    const data = {
      email: values.resetEmail,
    };
    setLoading(true);
    setLoginError(null);
    try {
      // const response = await Axios.post(
      //   `${basePath.url}auth/verify_reset_password_email`,
      //   data
      // );

      const response = await Axios.post(
        `${basePath.url}auth/reset_password_email`,
        data
      );

      if (response.data.message === "success") {
        actions.resetForm();
        setLogText(
          " Recovery Link has been sent to your email address. Please click the link and then proceed to login."
        );
        setLoading(false);
        setLogType("login");
      } else {
        setLoading(false);
        setLoginError(response.data.message);
        actions.resetForm();
      }
    } catch (err) {
      setLoginError(err.message);
      setLoading(false);
      actions.resetForm();
    }
  };

  const validateLogin = (values) => {
    let errors = {};

    if (!values.loginEmail) {
      errors.loginEmail = "Please enter your email address";
    } else if (
      !/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/i.test(
        values.loginEmail
      )
    ) {
      errors.loginEmail = "Invalid email format";
    }
    if (!values.loginPassword) {
      errors.loginPassword = "Please enter your password";
    }

    return errors;
  };

  const validateReset = (values) => {
    let errors = {};

    if (!values.resetEmail) {
      errors.resetEmail = "Please enter your email";
    } else if (
      !/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/i.test(
        values.resetEmail
      )
    ) {
      errors.resetEmail = "Please enter a valid email";
    }

    return errors;
  };

  const initialValuesRegistration = {
    name: "",
    email: "",
    password: "",
    confirmPassword: "",
  };

  const onSubmitRegistration = async (values, actions) => {
    setLogText("");

    const data = {
      email: values.email,
      name: values.name,
      mobileNo: values.mobileNo,
      password: values.password,
    };
    setLoading(true);
    setLoginError(null);
    try {
      const response = await Axios.post(
        `${basePath.url}auth/register_user`,
        data
      );

      if (response.data.message === "success") {
        setLogText(
          "Email Verification Link has been sent to your email address. Please click the link to verify your account."
        );
        setLoading(false);
        setLoginError(null);
        actions.resetForm();
        //setLogType("login");
      } else {
        setLoading(false);
        setLoginError(response.data.description);
        // setLogText(response.data.description);
        setLogText("");

        //actions.resetForm();
      }
    } catch (err) {
      setLoginError(err.message);
      setLoading(false);
      setLogText("");
      //actions.resetForm();
    }
  };

  const validateRegistration = (values) => {
    let errors = {};

    if (!values.name) {
      errors.name = "Please enter your name";
    }

    if (!values.email) {
      errors.email = "Email is required";
    } else if (
      !/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/i.test(
        values.email
      )
    ) {
      errors.email = "Invalid Email Format!";
    }

    if (!values.mobileNo) {
      errors.mobileNo = "Your mobile number is required";
    }

    if (!values.password) {
      errors.password = "Please enter your password";
    } else if (values.password.length < 6) {
      errors.password = "Password must be at least 6 characters";
    } else if (
      // /^(?=.*[a-zA-Z])(?=.*\d)(?=.*[!@#$%^&*()_+])[A-Za-z\d][A-Za-z\d!@#$%^&*()_+]{5,}$/i
      //  "Password must contain a mix of lowercase letters, uppercase letters, numbers & symbols";
      // !/^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{6,}$/i.test(values.password)
      !/[0-9a-z]{6,}/i.test(values.password)
    ) {
      errors.password =
        "Password must contain at least one letter and one number";
    }

    if (!values.confirmPassword) {
      errors.confirmPassword = "Required";
    } else if (values.password !== values.confirmPassword) {
      errors.confirmPassword = "Passwords do not match";
    }

    return errors;
  };

  const formikLogin = useFormik({
    initialValues: initialValuesLogin,

    onSubmit: onSubmitLogin,
    validate: validateLogin,
  });

  const formikRegistration = useFormik({
    initialValues: initialValuesRegistration,
    onSubmit: onSubmitRegistration,
    validate: validateRegistration,
  });

  const formikReset = useFormik({
    initialValues: initialValuesReset,
    onSubmit: onSubmitReset,
    validate: validateReset,
  });

  return (
    <Dialog
      open={openLoginDialog}
      onClose={() => {
        setOpenLoginDialog(false);
        setErrorGoogleAuth(null);
        setLoginError(null);
        setLoading(false);
        setLoadingGoodleAuth(false);
      }}
    >
      <DialogContent
        style={{
          paddingTop: "10px",
          paddingRight: 0,
          paddingLeft: 0,
          overflowY: "revert",
        }}
        // className="login-form"
      >
        <div className="login-form">
          <div className="dialog-title">
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                gap: 20,
                width: "100%",
              }}
            >
              <div
                style={{
                  width: "98%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <HeaderText
                  type="h5"
                  text={
                    logType === "login"
                      ? "Sign in"
                      : logType === "signup"
                      ? "Create account"
                      : "Forgot password"
                  }
                  fWeight={400}
                />
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  width: "2%",
                  padding: 5,
                }}
              >
                <CloseOutlined
                  sx={{
                    cursor: "pointer",
                  }}
                  onClick={() => {
                    setOpenLoginDialog(false);
                    setLogText("");
                    setLoginError(null);
                  }}
                />
              </div>
            </div>
            <div style={{ width: "auto", textAlign: "left" }}>
              {logType === "reset" ? (
                <Typography variant="subtitle2" sx={{ color: "black" }}>
                  We'll send a password reset link to your email
                </Typography>
              ) : null}
            </div>
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              width: "100%",
              padding: "0px",
              paddingTop: "5px",
            }}
          >
            <Typography
              variant="subtitle1"
              style={{ color: "crimson", fontSize: "14px", fontWeight: 400 }}
            >
              {loginError && <p>{loginError}</p>}
              {errorGoogleAuth && <p>{errorGoogleAuth}</p>}
            </Typography>
            {/* <div>{feedback && <p>{feedback}</p>}</div> */}
            <div>
              {loading ? (
                // <CircularProgress size="large" color="success" />
                <span>
                  <CircularProgress />
                </span>
              ) : null}
            </div>
          </div>
          <div
            style={{
              width: "100%",
              textAlign: "center",
              boxSizing: "border-box",
              margin: "05px auto",
            }}
          >
            {logText !== "" ? (
              <Typography
                variant="body2"
                sx={{ color: "green", textOverflow: "clip" }}
              >
                {logText}
              </Typography>
            ) : null}
          </div>
          {logType === "login" ? (
            <form
              onSubmit={formikLogin.handleSubmit}
              // className="loginForm"
              autoComplete="off"
              style={{
                padding: "5px",
                paddingTop: "10px",
                boxSizing: "border-box",
              }}
            >
              <div className="formInput">
                {/* <label>Email</label> */}
                <input
                  placeholder="Email"
                  className={
                    formikLogin.touched.loginEmail &&
                    formikLogin.errors.loginEmail
                      ? "inputError"
                      : null
                  }
                  autoComplete="false"
                  type="text"
                  id="loginEmail"
                  name="loginEmail"
                  value={formikLogin.values.loginEmail}
                  onChange={formikLogin.handleChange}
                  onBlur={formikLogin.handleBlur}
                />

                {formikLogin.touched.loginEmail &&
                formikLogin.errors.loginEmail ? (
                  <span className="errorSpan">
                    {formikLogin.errors.loginEmail}
                  </span>
                ) : null}
              </div>
              <div className="formInput">
                {/* <label>Password</label> */}
                <input
                  placeholder="Password"
                  className={
                    formikLogin.touched.loginPassword &&
                    formikLogin.errors.loginPassword
                      ? "inputError"
                      : null
                  }
                  autoComplete="false"
                  type="password"
                  id="loginPassword"
                  name="loginPassword"
                  value={formikLogin.values.loginPassword}
                  onChange={formikLogin.handleChange}
                  onBlur={formikLogin.handleBlur}
                />
                {formikLogin.touched.loginPassword &&
                formikLogin.errors.loginPassword ? (
                  <span className="errorSpan">
                    {formikLogin.errors.loginPassword}
                  </span>
                ) : null}
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  alignItems: "center",
                  cursor: "pointer",
                  marginBottom: 20,
                }}
                onClick={() => {
                  setLogType("reset");
                  setLogText("");
                  setLoginError(null);
                }}
              >
                <Typography
                  variant="subtitle2"
                  sx={{ color: "#2470f4", fontWeight: 600 }}
                >
                  Forgot Password?
                </Typography>
              </div>
              <Button
                disabled={formikLogin.isSubmitting}
                className="button secondary"
                style={{
                  width: "100%",
                  textTransform: "capitalize",
                  fontWeight: 600,
                  // backgroundColor: "#011846",
                  // color: "#fff",
                }}
                type="submit"
              >
                <a
                  style={{
                    display: "block",
                    textAlign: "center",
                    cursor: "pointer",
                    // padding: "4px 3px",
                    width: "100%",
                  }}
                >
                  Log In
                </a>
              </Button>
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  padding: 10,
                  gap: 10,
                }}
              >
                <div className="textDivider"></div>
                <div style={{}}>
                  <Typography variant="subtitle2">
                    <span>or</span>
                  </Typography>
                </div>
                <div className="textDivider"></div>
              </div>
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                  padding: 10,
                  cursor: "pointer",
                }}
                onClick={handleGoogleLogin}
              >
                {loadingGoodleAuth ? (
                  // <CircularProgress size="large" color="success" />
                  <span>
                    <CircularProgress style={{ fontSize: 10 }} />
                  </span>
                ) : (
                  <ButtonGoogle />
                )}
              </div>

              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",

                  marginBottom: 20,
                  marginTop: 20,
                }}
              >
                <Typography variant="subtitle2">
                  Dont't have an account?{" "}
                  <span
                    style={{
                      cursor: "pointer",
                      color: "#2470f4",
                      fontWeight: 600,
                    }}
                    onClick={() => {
                      setLogType("signup");
                      setLogText("");
                      setLoginError(null);
                    }}
                  >
                    Sign Up
                  </span>
                </Typography>
              </div>
            </form>
          ) : null}
          {logType === "signup" ? (
            <form
              autoComplete="off"
              onSubmit={formikRegistration.handleSubmit}
              // className="loginForm"
              style={{
                padding: "5px",
                paddingTop: "10px",
                boxSizing: "border-box",
              }}
            >
              <div className="formInput">
                {/* <label>Name</label> */}
                <input
                  placeholder="Name"
                  className={
                    formikRegistration.touched.name &&
                    formikRegistration.errors.name
                      ? "inputError"
                      : null
                  }
                  type="text"
                  id="name"
                  name="name"
                  value={formikRegistration.values.name}
                  onChange={formikRegistration.handleChange}
                  onBlur={formikRegistration.handleBlur}
                />
                {formikRegistration.touched.name &&
                formikRegistration.errors.name ? (
                  <span className="errorSpan">
                    {formikRegistration.errors.name}
                  </span>
                ) : null}
              </div>
              <div className="formInput">
                {/* <label>Email</label> */}

                <input
                  placeholder="Email"
                  autoComplete="off"
                  className={
                    formikRegistration.touched.email &&
                    formikRegistration.errors.email
                      ? "inputError"
                      : null
                  }
                  type="email"
                  id="email"
                  name="email"
                  value={formikRegistration.values.email}
                  onChange={formikRegistration.handleChange}
                  onBlur={formikRegistration.handleBlur}
                />
                {formikRegistration.touched.email &&
                formikRegistration.errors.email ? (
                  <span className="errorSpan">
                    {formikRegistration.errors.email}
                  </span>
                ) : null}
              </div>
              <div className="formInput">
                {/* <label>Mobile No</label> */}
                <input
                  placeholder="Mobile Number"
                  className={
                    formikRegistration.touched.mobileNo &&
                    formikRegistration.errors.mobileNo
                      ? "inputError"
                      : null
                  }
                  type="number"
                  id="mobileNo"
                  name="mobileNo"
                  value={formikRegistration.values.mobileNo}
                  onChange={formikRegistration.handleChange}
                  onBlur={formikRegistration.handleBlur}
                />
                {formikRegistration.touched.mobileNo &&
                formikRegistration.errors.mobileNo ? (
                  <span className="errorSpan">
                    {formikRegistration.errors.mobileNo}
                  </span>
                ) : null}
              </div>
              <div className="formInput">
                {/* <label>Password</label> */}
                <input
                  placeholder="Password"
                  className={
                    formikRegistration.touched.password &&
                    formikRegistration.errors.password
                      ? "inputError"
                      : null
                  }
                  autoComplete="false"
                  type="password"
                  id="password"
                  name="password"
                  value={formikRegistration.values.password}
                  onChange={formikRegistration.handleChange}
                  onBlur={formikRegistration.handleBlur}
                />
                <Typography
                  variant="subtitle2"
                  style={{ marginLeft: 10, fontSize: 12 }}
                >
                  Password must contain 6 or more characters
                  <br /> with at least 1 letter and 1 number
                </Typography>
                {formikRegistration.touched.password &&
                formikRegistration.errors.password ? (
                  <span className="errorSpan">
                    {formikRegistration.errors.password}
                  </span>
                ) : null}
              </div>
              <div className="formInput">
                {/* <label>Confirm Password</label> */}
                <input
                  placeholder="Confirm Password"
                  className={
                    formikRegistration.touched.confirmPassword &&
                    formikRegistration.errors.confirmPassword
                      ? "inputError"
                      : null
                  }
                  type="password"
                  id="confirmPassword"
                  name="confirmPassword"
                  value={formikRegistration.values.confirmPassword}
                  onChange={formikRegistration.handleChange}
                  onBlur={formikRegistration.handleBlur}
                />
                {formikRegistration.touched.confirmPassword &&
                formikRegistration.errors.confirmPassword ? (
                  <span className="errorSpan">
                    {formikRegistration.errors.confirmPassword}
                  </span>
                ) : null}
              </div>

              <Button
                disabled={formikRegistration.isSubmitting}
                className="button secondary"
                style={{ width: "100%", marginTop: "20px" }}
                type="submit"
              >
                <a
                  style={{
                    display: "block",
                    textAlign: "center",
                    cursor: "pointer",
                    padding: "10px 10px",
                    width: "100%",
                    textTransform: "capitalize",
                    fontWeight: 600,
                  }}
                >
                  Create Account
                </a>
              </Button>
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  padding: 10,
                  gap: 10,
                }}
              >
                <div className="textDivider"></div>
                <div style={{}}>
                  <Typography variant="subtitle2">
                    <span>or</span>
                  </Typography>
                </div>
                <div className="textDivider"></div>
              </div>
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                  padding: 10,
                  cursor: "pointer",
                }}
                onClick={handleGoogleLogin}
              >
                {loadingGoodleAuth ? (
                  // <CircularProgress size="large" color="success" />
                  <span>
                    <CircularProgress style={{ fontSize: 15 }} />
                  </span>
                ) : (
                  <ButtonGoogle />
                )}
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",

                  marginBottom: 20,
                  marginTop: 40,
                }}
              >
                <Typography variant="subtitle2">
                  Already have an account?{" "}
                  <span
                    style={{
                      cursor: "pointer",
                      color: "#2470f4",
                      fontWeight: 600,
                    }}
                    onClick={() => {
                      setLogType("login");
                      setLogText("");
                      setLoginError(null);
                    }}
                  >
                    Log In
                  </span>
                </Typography>
              </div>
            </form>
          ) : null}
          {logType === "reset" ? (
            <form
              onSubmit={formikReset.handleSubmit}
              className="loginForm"
              autoComplete="off"
              style={{
                padding: "5px",
                paddingTop: "10px",
                boxSizing: "border-box",
              }}
            >
              <div className="formInput">
                {/* <label>Email</label> */}
                <input
                  placeholder="Email"
                  className={
                    formikReset.touched.resetEmail &&
                    formikReset.errors.resetEmail
                      ? "inputError"
                      : null
                  }
                  autoComplete="false"
                  type="text"
                  id="resetEmail"
                  name="resetEmail"
                  value={formikReset.values.resetEmail}
                  onChange={formikReset.handleChange}
                  onBlur={formikReset.handleBlur}
                />
                {formikReset.touched.resetEmail &&
                formikReset.errors.resetEmail ? (
                  <span className="errorSpan">
                    {formikReset.errors.resetEmail}
                  </span>
                ) : null}
              </div>

              <Button
                disabled={formikReset.isSubmitting}
                className="button secondary"
                style={{
                  width: "100%",
                  textTransform: "capitalize",
                  fontWeight: 600,
                }}
                type="submit"
              >
                <a
                  style={{
                    display: "block",
                    textAlign: "center",
                    cursor: "pointer",
                    padding: "10px 10px",
                    width: "100%",
                  }}
                >
                  Send Password to Reset Link
                </a>
              </Button>
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",

                  marginBottom: 20,
                  marginTop: 20,
                  gap: 10,
                }}
              >
                <ArrowBackOutlined />
                <Typography variant="subtitle2">
                  <span
                    style={{
                      cursor: "pointer",
                      color: "#2470f4",
                      fontWeight: 600,
                    }}
                    onClick={() => {
                      setLogType("login");
                      setLogText("");
                      setLoginError(null);
                    }}
                  >
                    Back to Login
                  </span>
                </Typography>
              </div>
            </form>
          ) : null}
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default LoginPage;
